import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class PromoCodeService {
  url: string = environment.api.endpoint;

  constructor(private http: HttpClient) { }

  getByCode(data: any): any {
    return this.http.get(`${this.url}/promocode/code`, { params: data });
  }

  create(form: any): any {
    return this.http.post(`${this.url}/promocode/create`, form);
  }

  update(id: string, form: any): any {
    return this.http.put(`${this.url}/promocode/update/${id}`, form);
  }

  delete(data: any): any {
    return this.http.post(`${this.url}/promocode/delete`, data);
  }

  getAllByOrganization(filter: any): any {
    return this.http.get(`${this.url}/promocodes/organization`, { params: filter });
  }
}